export default __webpack_public_path__ + "static/media/res-logo.774a0d4b.svg";